import { olx } from 'openlayers';
import { ToggleControl } from './toggle-control';

export class FullscreenControl extends ToggleControl {
  constructor(options: olx.control.ControlOptions = {}) {
    const buttonClass = 'bom-ol-fullscreen icon-svg';
    const classNameOn = 'icon-outline-fullscreen_exit-24px';
    const classNameOff = 'icon-outline-zoom_out_map-24px';

    super(buttonClass, classNameOn, classNameOff, options);
  }
}
